<div class="report-progress">
  <div class="report-progress__card" role="status" aria-live="polite">
    <div class="report-progress__bar" aria-hidden="true">
      <span class="report-progress__bar-fill"></span>
    </div>

    <div class="report-progress__header">
      <div class="report-progress__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
          <polyline points="14 3 14 9 20 9"></polyline>
          <line x1="8" y1="13" x2="16" y2="13"></line>
          <line x1="8" y1="17" x2="13" y2="17"></line>
        </svg>
      </div>

      <div class="report-progress__heading">
        <h3 class="report-progress__title">{{ title }}</h3>
        <p class="report-progress__subtitle">{{ subtitle }}</p>
      </div>
    </div>

    <ul class="report-progress__stages" *ngIf="visibleStages.length; else seedState">
      <li class="report-progress__more" *ngIf="hasHiddenStages" aria-hidden="true">
        <span class="report-progress__more-dot"></span>
        <span class="report-progress__more-dot"></span>
        <span class="report-progress__more-dot"></span>
      </li>
      <li
        *ngFor="let stage of visibleStages; let last = last; trackBy: trackByMessage"
        class="report-progress__stage"
        [class.report-progress__stage--done]="stage.done"
        [class.report-progress__stage--active]="!stage.done"
      >
        <span class="report-progress__stage-line" *ngIf="!last" aria-hidden="true">
          <span class="report-progress__stage-line-fill"></span>
        </span>

        <span class="report-progress__stage-indicator" aria-hidden="true">
          <span class="report-progress__stage-spinner" *ngIf="!stage.done"></span>
          <svg
            *ngIf="stage.done"
            class="report-progress__stage-check"
            viewBox="0 0 16 16"
            width="14"
            height="14"
            fill="none"
            stroke="currentColor"
            stroke-width="2.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M3.5 8.5l3 3 6-7"></path>
          </svg>
        </span>

        <span class="report-progress__stage-text">{{ stage.message }}</span>
      </li>
    </ul>

    <ng-template #seedState>
      <div class="report-progress__seed">
        <span class="report-progress__stage-spinner" aria-hidden="true"></span>
        <span class="report-progress__seed-text">{{ message || 'Starting…' }}</span>
      </div>
    </ng-template>
  </div>
</div>
